import { render, staticRenderFns } from "./MenuPageView.vue?vue&type=template&id=329605c8"
import script from "./MenuPageView.vue?vue&type=script&lang=js"
export * from "./MenuPageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports